import script from "./watermark.vue?vue&type=script&setup=true&lang=js"
export * from "./watermark.vue?vue&type=script&setup=true&lang=js"

import "./watermark.vue?vue&type=style&index=0&id=52e5066a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e5066a"]])

export default __exports__